export function getHeaderAndOriginAnnot(annotArr) {
  let pureAnnots
  let resultArr = []
  let groupedAnnotIndexArr = []

  annotArr.forEach((annot, index) => {
    if (annot.isGrouped && annot.isGrouped()) {
      let annotObj = {}
      let { groupElements } = annot

      groupedAnnotIndexArr.push(index)
      groupElements.forEach((annotInner) => {
        if(annotInner.isGroupHeader()) {
          annotObj.headerAnnot = annotInner
        } else {
          annotObj.originAnnot = annotInner
        }
      })
      
      resultArr.push(annotObj)
    }
  });

  for (let i = groupedAnnotIndexArr.length - 1; i >= 0; i--) {
    const annotIndex = groupedAnnotIndexArr[i];

    annotArr.splice(annotIndex, 1)
  }

  pureAnnots = filterAnnotationData(annotArr)
  pureAnnots.forEach((pureAnnot) => {
    resultArr.push({headerAnnot: pureAnnot, originAnnot: pureAnnot})
  })

  return resultArr
}
export function filterAnnotationData(annots) {
  const isPopup = (type) => type === 'popup';
  const isWidget = (type) => type === 'widget';
  const isReplace = (annot) => {
    if (annot.getIntent() === 'Replace' || (annot.isReplace && annot.isReplace())) {
      return true
    }
  }
  annots = annots.filter(
    (annot) =>
      !isReplace(annot) && annot.isMarkup() && !isPopup(annot.getType()) && !isWidget(annot.getType()) && annot.getReplies && (annot.isStateAnnot ? !annot.isStateAnnot() : true),
  );

  const replies = [];
  const states = [];

  annots.forEach((annot) => {
    const annotReplies = annot.getReplies();
    replies.push(...annotReplies);
    replies.forEach(function itr(reply) {
      if (!reply || !reply.getReplies) {
        return;
      }
      const replyReplies = reply.getReplies();
      replies.push(...replyReplies);
      replyReplies.forEach(itr);
    });
    states.push(...annot.getReviewStates());
    states.push(...annot.getMarkedStates());
  });
  let filteredAnnots = annots.filter((annot) => /* replies.indexOf(annot) === -1 && */ states.indexOf(annot) === -1);
  // filteredAnnots.forEach((annot, index) => {
  //   if (annot.getIntent() === 'Replace' || (annot.isReplace && annot.isReplace())) {
  //     let header;
  //     annot.groupElements.forEach((gannot) => {
  //       if (gannot.getType() == 'caret') {
  //         header = gannot;
  //       }
  //       if (gannot !== annot) {
  //         const index = filteredAnnots.indexOf(gannot);
  //         index > -1 && filteredAnnots.splice(index, 1);
  //       }
  //     });
  //     filteredAnnots[index] = header;
  //   }
  // });
  return filteredAnnots;
}
export function getAnnotFromXFDF(xfdfString) {
  let result = '';
  const domParser = new DOMParser();
  const xmlDom = domParser.parseFromString(xfdfString, 'text/xml');
  const annotsDom = xmlDom.querySelector('annots');

  for (let i = 0; i < annotsDom.children.length; i++) {
    const item = annotsDom.children[i];
    
    result += item.outerHTML;
  }
  // annotsDom.children.forEach((item) => {
  //   result += item.outerHTML;
  // });

  return result;
}
export function setAnnotToXFDF(annotString) {
  return `<?xml version="1.0" encoding="UTF-8"?><xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve"><annots>${annotString}</annots>
  </xfdf>`;
}
export function getAnnotInReplyTo(annotXfdfString) {
  const annotInReplyToReg = /inreplyto=\"([^"]*)\"/
  const matchedArr = annotXfdfString.match(annotInReplyToReg)
  const annotInReplyTo = matchedArr && annotXfdfString[0].match(annotInReplyToReg)[0].split('=')[1].replaceAll('"', '')

  return annotInReplyTo
}
export function getAnnotRenderInfo({annotItem, pageIndex, annotName, annotDelFlag,userEmail,cUserID }) {
  const annotPageReg = /page=\"([^"]*)\"/
  const annotNameReg = /name=\"([^"]*)\"/
  const annotInReplyToReg = /inreplyto=\"([^"]*)\"/
  const matchedArr = annotItem.match(annotInReplyToReg)
  const resAnnotInReplyTo = matchedArr && matchedArr[0].split('=')[1].replaceAll('"', '')
  const resAnnotPage = (pageIndex !== undefined) ? pageIndex : parseInt(annotItem.match(annotPageReg)[0].split('=')[1].replaceAll('"', ''))
  const resAnnotName = annotName || annotItem.match(annotNameReg)[0].split('=')[1].replaceAll('"', '')


  return {
    annotName: resAnnotName,
    annotPage: resAnnotPage,
    annotInReplyTo: resAnnotInReplyTo,
    annotItem: annotItem,
    annotDelFlag,
    userEmail,
    cUserID
  }
}


export const collaborationOnlyReadContextmenus = ['fv--highlight-contextmenu',
  'fv--strikeout-contextmenu',
  'fv--underline-contextmenu',
  'fv--squiggly-contextmenu',
  'fv--replace-contextmenu',
  'fv--caret-contextmenu',
  'fv--callout-contextmenu',
  'fv--text-contextmenu',
  'fv--fileattachment-contextmenu',
  'fv--typewriter-contextmenu',
  'fv--textbox-contextmenu',
  'fv--ink-contextmenu',
  'fv--square-contextmenu',
  'fv--circle-contextmenu',
  'fv--line-contextmenu',
  'fv--linearrow-contextmenu',
  'fv--polyline-contextmenu',
  'fv--polygon-contextmenu',
  'fv--polygoncloud-contextmenu',
  'fv--image-contextmenu'];
  export const collaborationOnlyReadContextmenuItems = ['fv--contextmenu-item-select-annotation',
      'fv--contextmenu-item-select-text-image',
      'fv--contextmenu-item-marquee-zoom',
      'fv--text-selection-tooltip'];
export async function enableCollaborationOnlyRead() {
  const fn = ()=>{
    const hideContextmenus = collaborationOnlyReadContextmenus;
    return pdfui.getRootComponent().then(root => {
      // 隐藏工具栏
      const collaborationToolbar = root.getComponentByName('collaboration-toolbar');
      collaborationToolbar && collaborationToolbar.hide();
      hideContextmenus.forEach(item=>{
        const component = root.getComponentByName(item);
        if(component) {
          component.lock();
          // component.querySelectorAll('*').forEach(it => it.lock());
        }
      });
    })
  }
  fn();
  setTimeout(() => { fn(); }, 500);

  collaborationOnlyReadContextmenuItems.forEach(async item=>{
    const component = await pdfui.getComponentByName(item);
    if(component) {
      component.lock();
    }
  });
}
export async function disableCollaborationOnlyRead() {
  const fn = ()=>{
    collaborationOnlyReadContextmenus.forEach(async item=>{
      const component = await pdfui.getComponentByName(item);
      if(component) {
        component.querySelectorAll('*').forEach(it => it.unlock());
      }
    });
  }
  fn();

  const pdfDoc = await pdfui.getCurrentPDFDoc();
  if (!pdfDoc) return;
  collaborationOnlyReadContextmenuItems.forEach(async item=>{
    const component = await pdfui.getComponentByName(item);
    if(component) {
      component.controller.changePermission(pdfDoc);
    }
  });
}

export function annotExportToJSON(annot) {
  if (!annot) {
    return
  }

  const name = annot.info.name
  const page = annot.page.info.index

  return {
    name,
    page
  }
}
export function getHeaderAnnot(annot) {
  if (!annot.isGrouped || !annot.isGrouped() || annot.isGroupHeader()) {
    return annot
  }

  let headerAnnot

  annot.groupElements.some((item) => {
    if (item.isGroupHeader()) {
      headerAnnot = item

      return true
    }
  })

  return headerAnnot
}